import { Component, OnDestroy } from '@angular/core'
import { Observable, of, Subscription, tap } from 'rxjs'
import { FormState } from 'ngrx-forms'
import { CustomerInformationState, selectProfileState } from '../user-profile.state'
import { Store } from '@ngrx/store'
import { HttpService } from '@api/http.service'
import { ActivatedRoute, Router } from '@angular/router'
import { MatSnackBar } from '@angular/material/snack-bar'
import { CustomerInfoActions } from '../user-profile.actions'
import { ErrorSnackBarComponent } from '../../../utils/components/error-snack-bar/error-snack-bar.component'
import { catchError } from 'rxjs/operators'
import { EditPage } from '../../../utils/services/can-deactivate-guard.service'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'cover-change-birthday',
  templateUrl: './change-birthday.component.html',
  styleUrls: ['./change-birthday.component.scss'],
})
export class ChangeBirthdayComponent extends EditPage implements OnDestroy {
  changeBirthdateFormState$: Observable<FormState<any>>
  currentBirthdate$: Observable<any>
  userAddressState$: Observable<CustomerInformationState>
  userAddress: CustomerInformationState | undefined
  subscription: Subscription
  newBirthDate: string | null = ''

  constructor(
    private readonly store: Store,
    private readonly httpService: HttpService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly snackbar: MatSnackBar,
    private readonly datePipe: DatePipe,
  ) {
    super()
    this.changeBirthdateFormState$ = this.store.select(selectProfileState.changeBirthdateControls)
    this.currentBirthdate$ = this.store.select(selectProfileState.birthdateState)
    this.userAddressState$ = this.store.select(selectProfileState.customerInformationState)
    this.subscription = this.userAddressState$
      .pipe(
        tap(state => {
          this.userAddress = state
        }),
      )
      .subscribe()
  }
  onDateChange(event: any): void {
    this.newBirthDate = this.datePipe.transform(event.value, 'dd.MM.yyyy')
    this.formIsDirty = true
  }

  onSubmit(): void {
    if (this.formIsDirty && this.newBirthDate && this.userAddress) {
      this.pending = true
      this.httpService
        .updateAddress({
          customer_number: this.userAddress.customerNumber,
          customer_sub_number: this.userAddress.customerSubNumber,
          first_name: this.userAddress.firstName,
          last_name: this.userAddress.lastName,
          mobile: this.userAddress.mobile,
          phone_number: this.userAddress.phoneNumber,
          postal_code: this.userAddress.address.postalCode,
          street_2: this.userAddress.address.street2,
          street: this.userAddress.address.street,
          city: this.userAddress.address.city,
          country_code: this.userAddress.address.countryCode,
          email: this.userAddress.email,
          company: this.userAddress?.address.company,
          birthdate: this.newBirthDate,
        })
        .pipe(
          tap(response => {
            this.pending = false
            if (response.parameter === 'success') {
              this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
                this.store.dispatch(CustomerInfoActions.customerInfoLoad({ payload: this.userAddress!.uuid }))
              })
            } else {
              this.snackbar.openFromComponent(ErrorSnackBarComponent, {
                duration: 5000,
                panelClass: ['error-snack-bar'],
              })
            }
          }),
          catchError(err => {
            this.pending = false
            this.snackbar.openFromComponent(ErrorSnackBarComponent, {
              duration: 5000,
              panelClass: ['error-snack-bar'],
            })
            return of(err)
          }),
        )
        .subscribe()
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
